var EEnvatoPurchaseStatus = /*#__PURE__*/function (EEnvatoPurchaseStatus) {
  EEnvatoPurchaseStatus["Unconfirmed"] = "unconfirmed";
  EEnvatoPurchaseStatus["Complete"] = "complete";
  return EEnvatoPurchaseStatus;
}(EEnvatoPurchaseStatus || {});
export { EEnvatoPurchaseStatus };